module.exports = __webpack_public_path__ + "static/img/bb9856f78310820fb10c883d1f54c15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mode0-show-2.png
// module id = 1i5/
// module chunks = 1